"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var content_parser_1 = require("@dynamynd/content-parser");

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var react_onclickoutside_1 = __importDefault(require("react-onclickoutside"));

var constants_1 = require("./constants");

var index_1 = require("./index");

var Modal_1 = require("./Modal");

var ContentTypeEnum;

(function (ContentTypeEnum) {
  ContentTypeEnum["title"] = "title";
  ContentTypeEnum["content"] = "content";
})(ContentTypeEnum || (ContentTypeEnum = {}));

var BigModal =
/** @class */
function (_super) {
  __extends(BigModal, _super);

  function BigModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      contentWidth: 0,
      titleWidth: 0
    };

    _this.componentDidMount = function () {
      window.addEventListener('keyup', _this.keyUpHandler);
    };

    _this.keyUpHandler = function (event) {
      _this.handleKeyUp(event, _this.props);
    };

    _this.handleChange = function (event, type) {
      if (type === void 0) {
        type = ContentTypeEnum.content;
      }

      if (type === ContentTypeEnum.title) {
        _this.setState({
          titleWidth: event.nativeEvent.layout.width
        });

        return;
      }

      _this.setState({
        contentWidth: event.nativeEvent.layout.width
      });
    };

    return _this;
  }

  BigModal.prototype.componentWillUnmount = function () {
    window.removeEventListener('keyup', this.keyUpHandler);
  };

  BigModal.prototype.handleKeyUp = function (event, props) {
    if (event.keyCode === 27) {
      props.modalClose();
    }
  };

  BigModal.prototype.render = function () {
    var _this = this;

    var _a = this.props;
    return react_1.default.createElement(responsive_1.ResponsiveContext.Consumer, null, function (_a) {
      var width = _a.width,
          height = _a.height,
          activeBreakpoint = _a.activeBreakpoint;
      return react_1.default.createElement(Modal_1.WrapperPopup, {
        width: width,
        height: height
      }, react_1.default.createElement(index_1.ClickOutside, {
        modalClose: _this.props.modalClose
      }, react_1.default.createElement(Modal_1.ImageModal, {
        resizeMode: "contain",
        source: {
          uri: components_lib_1.appConfig.images.popup
        }
      })), react_1.default.createElement(Modal_1.ContentWrapper, null, react_1.default.createElement(Modal_1.TitleBox, {
        activeBreakpoint: activeBreakpoint,
        onLayout: function onLayout(event) {
          return _this.handleChange(event, ContentTypeEnum.title);
        }
      }, react_1.default.createElement(Modal_1.ModalTitle, {
        width: _this.state.titleWidth
      }, react_1.default.createElement(content_parser_1.ParsedContent, {
        content: constants_1.MODAL_CONSTANTS.TITLE
      }))), react_1.default.createElement(Modal_1.ContentBox, {
        onLayout: function onLayout(event) {
          return _this.handleChange(event);
        }
      }, react_1.default.createElement(react_native_1.ScrollView, null, react_1.default.createElement(components_lib_1.Paragraph, {
        size: components_lib_1.ParagraphSizeEnum.normal,
        centered: true
      }, react_1.default.createElement(content_parser_1.ParsedContent, {
        content: constants_1.MODAL_CONSTANTS.CONTENT
      })))), react_1.default.createElement(Modal_1.ButtonBox, null, react_1.default.createElement(Modal_1.WrappButton, {
        activeBreakpoint: activeBreakpoint
      }, react_1.default.createElement(components_lib_1.Button, {
        text: _this.props.textButton,
        uppercase: true,
        onPress: _this.props.modalClose,
        disabled: false,
        type: components_lib_1.ButtonTypeEnum.primary
      })))));
    });
  };

  return BigModal;
}(react_1.default.Component);

exports.BigModal = BigModal;
exports.default = react_onclickoutside_1.default(BigModal);